var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTvBills(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Subscription",
    transform: "translate(-85 -590)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147995",
    "data-name": "Rectangle 147995",
    width: 47,
    height: 46,
    rx: 10,
    transform: "translate(85 590)",
    fill: "#1b1c1d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "tv-svgrepo-com",
    transform: "translate(99 603.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5461",
    "data-name": "Path 5461",
    d: "M2,16.333v-7.9A1.436,1.436,0,0,1,3.436,7H14.923a1.436,1.436,0,0,1,1.436,1.436v7.9a1.436,1.436,0,0,1-1.436,1.436H3.436A1.436,1.436,0,0,1,2,16.333Z",
    transform: "translate(0 -1.269)",
    fill: "none",
    stroke: "#fdfdfd",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5462",
    "data-name": "Path 5462",
    d: "M8.5,2.5l2.513,2.513L13.526,2.5",
    transform: "translate(-1.833)",
    fill: "none",
    stroke: "#fdfdfd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvBills);
export default __webpack_public_path__ + "static/media/tv_bills.acbfe3e85635c4f441cb7efc0974ed6c.svg";
export { ForwardRef as ReactComponent };